export const typesVehicles = {
  InitAction : 'Init_Action',
  GetVehicles: 'Get_Vehicles',
  EndAction  : 'End_Action'
}